import { Component, ViewChild, Inject, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { MatSidenav } from "@angular/material/sidenav";
import { DomSanitizer } from "@angular/platform-browser";
import { ConfirmDialogBox } from "../../../../../../src/app/admin/confirm-dialog/confirm-dialogbox";
import { NotificationService } from "../../../../../../src/app/admin/services/notification.service";
import { ApiserviceService } from "../../../../../../src/app/apiservice.service";
import { CommonfunctionService } from "../../../../../../src/app/services/commonfunction.service";
import { environment } from "../../../../../../src/environments/environment";
import { Map } from '../../../map_api/map';
import { LabelDialog } from "../label-dialog/label-dialog.component";
import { Subscription } from "rxjs";
/**
*
* <strong>List of API using</strong>
* <ol>
* <li>estapi_propertytypes_get</li>
* <li>estapi_assignments_assignment_id_patch</li>
* <li>estapi_getProperties_get</li>
* </ol>
*
*/
interface PropList {
  id: number,
  uid: number,
  property_name: string,
  userId: number,
  imageURL: string,
  username: string,
  buildYear: number,
  category: string,
  address: string
}

@Component({
  selector: 'createMap',
  templateUrl: './create-map.component.html',
  styleUrls: ['../../master-assignment.component.css']
})
export class CreateMapComponent implements OnDestroy {
  //for mat chips
  visible: boolean = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = true;
  //for mat chips
  MapObj: Map;
  map_overlay: any;
  mobile: boolean = false;
  map: any;
  drawingManager: any;
  circle: any;
  poly: any;
  polygon: any = [];
  selectedpolygon: any;
  selectedNeightbour: any;
  mode: string = '';
  polygons: any = [];
  tempPolygons: any = [];
  selectedType: any;
  saveLoader: boolean = false;
  getPropertyLoader: boolean = false;
  unassignproLimit = 20;
  unassignproOffset = 0;
  property_uids: any = null;
  assignment_access = {
    'GET': false,
    'POST': false,
    'PATCH': false,
    'DELETE': false
  }
  neighbourhoods: any = [];
  assignment_name: any;
  property_types: any = [];
  propdata: Array<PropList> = [];


  @ViewChild('gmap') gmapElement: any;
  @ViewChild('drawer') sidenav: MatSidenav;

  showFiller=false;
  private subs = new Subscription();

  constructor(public dialogRef: MatDialogRef<CreateMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,
    private readonly api: ApiserviceService,
    private readonly notify: NotificationService,
    private readonly dialog: MatDialog,
    private readonly fnc: CommonfunctionService,
    private cdr: ChangeDetectorRef) {
    iconRegistry.addSvgIcon('circle', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/dots-circle.svg'))
      .addSvgIcon('polygon', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/line-path.svg'));
    this.polygons = this.data.pObj.polygons;
    this.assignment_access = this.data.pObj.assignment_access;
    this.assignment_name = this.data.pObj.selectedAssignment.name;
    this.data.pObj.selected_unassProperties = [];
    this.neighbourhoods = this.data.pObj.neighbourhoods;
    this.getPropertyTypes();
  }
  getPropertyTypes() {
    const propertyTypeSub = this.api.getEmsData('propertytypes?sort_by=property_type_name').subscribe((data: any) => {
      data.forEach(e => {
        let obj = {
          added_date: e.added_date,
          "property_type_id": e.property_type_id,
          "property_type_label": e.property_type_label[this.api.language],
          "property_type_name": e.property_type_name,
          "status": e.status,
          "updated_by": e.updated_by,
          "updated_date": e.updated_date
        }
        this.property_types.push(obj);
      });
    })
    this.subs.add(propertyTypeSub);
  }
  filterByType(e) {
    let val = e.value;
    if (val) {
      this.selectedType = val;
    }
  }
  openMenu() {
    this.sidenav.open();
  }
  sidenavClose() {
    this.sidenav.close();
  }
  getLabel(data) {
    if (data) {
      return data.label[this.api.language];
    }
  }
  selectNeighbourhood(neigh) {
    let neighbourhood = this.fnc.getArrayValue('neigh_uid', neigh, this.neighbourhoods);
    let geomArr = [], newArr = [], geom = neighbourhood.geom, flag = false;
    geom = geom.replace('MULTIPOLYGON', '');
    geom = geom.replace('(((', '');
    geom = geom.replace(')))', '');
    geomArr = geom.split(',');
    geomArr.forEach(latlng => {
      newArr.push([latlng]);
    });
    this.polygon = newArr;
    //checking if polygon exists
    // if (this.polygons) {
    //   this.polygons.forEach(element => {
    //     if (element.geom == 'POLYGON((' + this.polygon.toString() + '))') {
    //       flag = true;
    //     }
    //   });
    // }
    if (!flag) {
      this.drawingManager.setDrawingMode(null);
      this.addLabel({ poly: { label: { [this.api.language]: neighbourhood.neigh_name }, geom: 'POLYGON((' + this.polygon.toString() + '))' } });
    } else {
      this.notify.notify('Area already exist', 'warn')
    }
  }
  currentArea(polygon) {
    let poly = new google.maps.Polygon({
      paths: this.getgeom(polygon.geom),
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 1,
      fillColor: '#FF0000',
      fillOpacity: 0.35
    });
    this.getBound(poly);
  }
  remove(poly) {
    let index = this.polygons.indexOf(poly);
    if (index >= 0) {
      this.polygons.splice(index, 1);
    }
    this.sidenavClose();
    this.saveDialog(true);
  }

  confirm(poly) {
    let dialogRef = this.dialog.open(ConfirmDialogBox, {
      width: '400px',
      panelClass: 'create-master-panel',
      data: {
        parent_data: this,
        message: `Are you sure you wish to delete Polygon - ${poly.label['1']}`
      }//optional
    });
    const confirmSub = dialogRef.afterClosed().subscribe(result => {
      if(result == 'YES'){
        this.remove(poly);
      }else{
        this.sidenavClose();
      }
    });
    this.subs.add(confirmSub);
  }
  confirmDialogYes(val){

  }
  add(event: MatChipInputEvent): void {
    let input = event.input;
    let value = event.value;

    // Add poly
    if ((value || '').trim()) {
      this.polygons.push({ label: 'extra' });
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  addLabel(neigh_obj = null) {

    let dialogRef = this.dialog.open(LabelDialog, {
      width: '450px',
      panelClass: 'create-master-panel',
      data: { parent: this, neigh_obj: neigh_obj }//optional
    });
    const addLabelSub = dialogRef.afterClosed().subscribe(result => {

    });
    this.subs.add(addLabelSub);
  }


  getgeom(data) {
    if (data != null) {
      let str = data;
      let result = str.match(/\(\((.*)\)\)/);
      let str2 = result[1];
      let latlon = str2.split(',');

      let temp = [];
      latlon.forEach(el => {
        let s = el.split(' ')
        temp.push({ "lat": +s[1], "lng": +s[0] });
      });
      return temp;
    }
  }
  getBound(polygon) {
    let bounds = new google.maps.LatLngBounds();
    let paths = polygon.getPaths();
    let path;
    for (let i = 0; i < paths.getLength(); i++) {
      path = paths.getAt(i);
      for (let ii = 0; ii < path.getLength(); ii++) {
        bounds.extend(path.getAt(ii));
      }
    }
    this.map.fitBounds(bounds);
  }
  initMap() {
    let lt = 29.370656;
    let ln = 47.978168;
    if (localStorage.getItem('city_detail')) {
      let city_detail = JSON.parse(localStorage.getItem('city_detail'));
      if (city_detail.lat) {
        lt = city_detail.lat;
        ln = city_detail.lon;
      }
    }
    let map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: { lat: lt, lng: ln },
      zoom: 12,
      mapTypeId: google.maps.MapTypeId.HYBRID
    });
    this.map_overlay = map.overlayMapTypes;
    this.map = map;

    //drowpolygons
    this.polygonDrow(map);

    this.drawingManager = new google.maps.drawing.DrawingManager({

      drawingMode: google.maps.drawing.OverlayType.MARKER,
      drawingControl: false,
      circleOptions: {
        strokeColor: '#F1AE65',
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: '#F1AE65',
        fillOpacity: 0.35,
        editable: false,
        draggable: false
      },
      polygonOptions: {
        editable: false,
        draggable: false
      }
    });

    google.maps.event.addListener(this.drawingManager, 'circlecomplete', (circle) => {
      let radius = circle.getRadius();
      let clat = circle.getCenter().lat();
      let clng = circle.getCenter().lng();
      let position = new google.maps.LatLng(clat, clng);
      map.setCenter(position);
      map.fitBounds(circle.getBounds());
      this.circle = circle;
      const numberOfEdges = 32;

      let polygonc = this.generateGeoJSONCircle(position, radius, numberOfEdges);
      this.polygon = polygonc.coordinates;
      this.addLabel();
    });


    google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
      let polygonBounds = polygon.getPath();
      let pBounds = polygon.getPaths();
      this.poly = polygon;
      let coordinates = [];
      for (let i = 0; i < polygonBounds.length; i++) {
        coordinates.push([polygonBounds.getAt(i).lng() + ' ' + polygonBounds.getAt(i).lat()]);
      }
      coordinates.push(coordinates[0]);
      this.polygon = [coordinates];
      this.addLabel();
    });

    google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
      this.drawingManager.setDrawingMode(null);
      if (event.type == 'circle') {
        let radius = event.overlay.radius;
        let center = { lat: event.overlay.center.lat() };
      }
    });

    // WMS layer
    // this.addLayer({
    //   'format': 'wms',
    //   'layerName': 'parcels',
    //   'name': 'parcels',
    //   'url': this.api.wms_url,
    //   'assignment': this.data.pObj.selectedAssignment.id
    // });
    // this.addLayer({
    //   'format': 'wms',
    //   'layerName': 'properties',
    //   'name': 'properties',
    //   'url': this.api.wms_url,
    //   'assignment': this.data.pObj.selectedAssignment.id
    // });

    // Geoserver
    this.addGeoLayer({
      'format': 'wms',
      'layerName': 'parcels',
      'name': 'parcels',
      'url': environment.geoestater + 'wms-layer',
      'assignment': this.data.pObj.selectedAssignment.id,
      'city_code': this.api.city_code,
      'city_id': this.api.city_id,
      'user_token': environment.user_token
    });
    this.addGeoLayer({
      'format': 'wms',
      'layerName': 'properties',
      'name': 'properties',
      'url': environment.geoestater + 'wms-layer',
      'assignment': this.data.pObj.selectedAssignment.id,
      'city_code': this.api.city_code,
      'city_id': this.api.city_id,
      'user_token': environment.user_token
    });
  }

  /// drow polyygons /////////////
  polygonDrow(map){

    if (this.polygons) {
      this.polygons.forEach(geomdata => {
        if (geomdata.geom) {
          let polyBroundory = new google.maps.Polygon({
            paths: this.getgeom(geomdata.geom),
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: '#FF0000',
            fillOpacity: 0.35
          });
          polyBroundory.setMap(map);
          this.getBound(polyBroundory);
          let info = new google.maps.InfoWindow();
          google.maps.event.addListener(polyBroundory, 'click', (e) => {
            this.selectedpolygon = geomdata;
            info.setContent(geomdata.label[this.api.language]);
            let latLng = e.latLng;
            info.setPosition(latLng);
            info.open(map);
            this.cdr.detectChanges();

            // Close icon click handler
            google.maps.event.addListener(info, 'closeclick', () => {
              this.selectedpolygon = null;
              console.log("Info window closed, selected polygon cleared", this.selectedpolygon);
              this.cdr.detectChanges();
            });
          });
        }
      });
    }
  }

  // addLayer(options) {
  //   if (!options.url) return;
  //   if (options.format == 'wms') {
  //     var layer =
  //       new google.maps.ImageMapType(
  //         {
  //           getTileUrl: (coord: google.maps.Point, zoom: number) => {
  //             // Compose URL for overlay tile
  //             var s = Math.pow(2, zoom);
  //             var twidth = 256;
  //             var theight = 256;
  //             //latlng bounds of the 4 corners of the google tile
  //             //Note the coord passed in represents the top left hand (NW) corner of the tile.
  //             var gBl = this.map.getProjection().fromPointToLatLng(new google.maps.Point(coord.x * twidth / s, (coord.y + 1) * theight / s)); // bottom left / SW
  //             var gTr = this.map.getProjection().fromPointToLatLng(new google.maps.Point((coord.x + 1) * twidth / s, coord.y * theight / s)); // top right / NE
  //             // Bounding box coords for tile in WMS pre-1.3 format (x,y)
  //             var bbox = parseFloat(gBl.lng()) + "," + parseFloat(gBl.lat()) + "," + parseFloat(gTr.lng()) + "," + parseFloat(gTr.lat());
  //             //base WMS URL
  //             var url = options.url;

  //             url += "&service=WMS";           //WMS service
  //             url += "&version=1.1.0";         //WMS version
  //             url += "&request=GetMap";        //WMS operation
  //             url += "&layers=gisdb:" + options.layerName; //WMS layers to draw
  //             url += "&styles=";               //use default style
  //             url += "&format=image/png";      //image format
  //             url += "&TRANSPARENT=TRUE";      //only draw areas where we have data
  //             url += "&srs=EPSG:4326";         //projection WGS84
  //             url += "&bbox=" + bbox;          //set bounding box for tile
  //             url += "&width=256";             //tile size used by google
  //             url += "&height=256";
  //             url += "&tiled=true";
  //             if (options.assignment) url += "&viewparams=assignment_no:" + options.assignment;
  //             //url = "http://51.15.221.10:8080/geoserver/gisdb/wms?service=WMS&version=1.1.0&request=GetMap&layers=gisdb:properties&styles=&
  //             //bbox=47.9728552938352,29.33170430618,48.0253671652929,29.379311241798&width=768&height=696&srs=EPSG:4326&format=image/png";
  //             return url;                 //return WMS URL for the tile
  //           },
  //           tileSize: new google.maps.Size(256, 256),
  //           opacity: 0.85,
  //           name: options.name
  //         });
  //     // add WMS layer to map
  //     this.map.overlayMapTypes.push(layer);
  //   }
  // }


  // geoserver
  addGeoLayer(options) {

    let layer =
      new google.maps.ImageMapType(
        {
          getTileUrl: (coord: google.maps.Point, zoom: number) => {
            // Compose URL for overlay tile
            let s = Math.pow(2, zoom);
            let twidth = 256;
            let theight = 256;

            //latlng bounds of the 4 corners of the google tile
            //Note the coord passed in represents the top left hand (NW) corner of the tile.
            let gBl = this.map.getProjection().fromPointToLatLng(new google.maps.Point(coord.x * twidth / s, (coord.y + 1) * theight / s)); // bottom left / SW
            let gTr = this.map.getProjection().fromPointToLatLng(new google.maps.Point((coord.x + 1) * twidth / s, coord.y * theight / s)); // top right / NE

            // Bounding box coords for tile in WMS pre-1.3 format (x,y)

            let bbox = parseFloat(gBl.lng()) + "," + parseFloat(gBl.lat()) + "," + parseFloat(gTr.lng()) + "," + parseFloat(gTr.lat());

            //base WMS URL=
            let url = `${options.url}?place_id=${options.city_id}&token=${options.user_token}&store=${options.city_code.toUpperCase()}_gisdb`;


            url += "&layers=gisdb:" + options.layerName; //WMS layers to draw
            // url += "&format=image/png";      //image format
            // url += "&transparent=TRUE";      //only draw areas where we have data
            // url += "&version=1.1.0";         //WMS version
            url += "&request=GetMap";        //WMS operation
            // url += "&service=WMS";           //WMS service
            url += "&styles=";               //use default style
            url += "&srs=EPSG:4326";         //projection WGS84
            url += "&bbox=" + bbox;          //set bounding box for tile
            url += "&width=256";             //tile size used by google
            url += "&height=256";
            if (options.assignment) url += "&viewparams=assignment_no:" + options.assignment;
            //url = "http://51.15.221.10:8080/geoserver/gisdb/wms?service=WMS&version=1.1.0&request=GetMap&layers=gisdb:properties&styles=&
            //bbox=47.9728552938352,29.33170430618,48.0253671652929,29.379311241798&width=768&height=696&srs=EPSG:4326&format=image/png";
            return url;                 //return WMS URL for the tile
          },
          tileSize: new google.maps.Size(256, 256),
          opacity: 0.85,
          name: options.name
        });

    // add WMS layer to map
    this.map.overlayMapTypes.push(layer);
  }



  refresh() {
    //this will change the zoom of the map
    this.map.setZoom(this.map.getZoom() + .000000000000001);
    //this will change the zoom again and load fresh tiles
    this.map.setZoom(Math.round(this.map.getZoom()));
  }

  //convert circle to polygon function
  generateGeoJSONCircle(center: any, radius: any, numSides: any) {

    let points = [],
      degreeStep = 360 / numSides;

    for (let i = 0; i < numSides; i++) {
      let gpos = google.maps.geometry.spherical.computeOffset(center, radius, degreeStep * i);
      points.push([gpos.lng() + ' ' + gpos.lat()]);
    };

    // Duplicate the last point to close the geojson ring
    points.push(points[0]);
    return {
      type: 'Polygon',
      coordinates: [points]
    };
  }

  /* custom functions for map & search */
  getMapBounds() {
    let bounds = this.map.getBounds();
    let bbox = '';
    if (bounds) {
      let isFull = 0;
      let min_lat = isFull ? -90 : bounds.getSouthWest().lat()
      let max_lat = isFull ? 90 : bounds.getNorthEast().lat()
      let min_lng = isFull ? 180 : bounds.getSouthWest().lng()
      let max_lng = isFull ? -180 : bounds.getNorthEast().lng()
      bbox = min_lng + ',' + min_lat + ',' + max_lng + ',' + max_lat;
    }
    return bbox;
  }
  drawCircle() {
    this.clearDrawing();
    this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE);
    this.mode = 'Circle';
  }

  drawPolygon() {
    this.clearDrawing();
    this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
    this.mode = 'Polygon';
  }

  reset() {
    this.drawingManager.setDrawingMode(null);
    this.mode = '';
  }

  clearDrawing(clear_all = false) {
    if (!this.circle && !this.poly) {
      this.drawingManager.setMap(this.map);
    }
    if (clear_all) {
      if (this.poly) {
        this.poly.setMap(null);
      }
      if (this.circle) {
        this.circle.setMap(null);
      }
    }
  }
  /**
   * map initalization
   */
  ngAfterViewInit() {
    this.initMap();
    this.drawingManager.setDrawingMode(null);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
  saveDialog(renew = false): void {
    if (!this.assignment_access.PATCH) {
      this.notify.notify('You are not authorized to update assignment', 'warn');
      return;
    }
    this.saveLoader = true;
    let body = {}, url = "assignments/" + this.data.pObj.selectedAssignment.assignment_id;

    body = {
      "assignment_id": this.data.assignment_id,
      "updated_by": +this.api.user_id,
      "geom": this.polygons
    }

    const updateStatusSub = this.api.patchEmsData(url, body).subscribe({
      next: (v) => {
        if (renew) {
          this.reset();
          this.initMap();
          // this.polygonDrow(this.map)

          this.drawingManager.setDrawingMode(null);
          this.drawingManager.setMap(this.map);
        }
        this.notify.notify("Area has been updated successfuly for this assignment", "success");
        this.saveLoader = false;
      },
      error: () => {
        this.saveLoader = false;
        this.data.pObj.getAssignment(false);
      },
    });
    this.subs.add(updateStatusSub);
  }

  getProperty(is_scroll = false, isLimit = false) {
  if(this.getPropertyLoader){
    return;
  }
    this.propdata = [];
    if (!is_scroll) {
      this.data.pObj.filteredPropListPolymain = [];
    }
    let polys: any = [], neigh: any = null;
    let propertyUids: any = null;
    let url = 'properties-copy';

    let address = '', property_name, build_year, category, images: any, img_url = "../assets/images/building_icon.png", image, img_list;
    if (this.selectedpolygon) {
      polys.push(this.selectedpolygon.geom)
    } else {
      polys = null;
    }
    if (this.property_uids) {
      propertyUids = this.property_uids;
    }
    if (this.selectedNeightbour) {
      neigh = this.selectedNeightbour.toString();
      // polys = null;
    }
    if (neigh == null && polys == null && propertyUids == null) {
      this.notify.notify('Please select Polygons or Neighbourhood Or enter propertyUids', 'warn');
      return;
    }

    this.data.pObj.unassignProploader = true;

    let body = {
      "assignmentId": this.data.pObj.selectedAssignment.id,
      "returnAttributeIds": false,
      "returnAttributeLabels": false,
      "returnDefaultValueForNulls": false,
      "returnGisProperties": false,
      "returnMasterValueIds": false,
      "returnMeasureUnits": false,
      "returnUserDetails": false,
      "showSeparateColumnForTableValues": false,
      "showTotalOfTableValues": false,
      "polygon": polys,
      "sortAsc": true,
      "sortBy": 'property_uid',
      "get_duplicate_assignment":false
    }

    if (neigh) body["neighUid"] = neigh;
    if (propertyUids != null) {
      body["propertyUid"] = propertyUids;
      body["attributeValue"] = propertyUids;
    }

    if (this.data.pObj.attributeValue != '') body["attributeValue"] = this.data.pObj.attributeValue;
    if (this.data.pObj.propertyUid != '') body["propertyUid"] = this.data.pObj.propertyUid;

    body["limit"] = (this.data.pObj.searchData.data == undefined || this.data.pObj.searchData.data == null) ? this.unassignproLimit : this.data.pObj.searchData.data.unassignproLimit;
    body["offset"] = this.unassignproOffset;
    body["status"] = '-100';

    if (this.selectedType && this.selectedType != 'All') body['propertyTypeIds'] = this.selectedType;
    this.getPropertyLoader = true;
    this.api.postEpsData(url, body)
      .subscribe({next: (data: any) => {
        this.getPropertyLoader = false;
        this.data.pObj.searchData = {
          body: body,
          url: url,
          data: this
        }
        this.data.pObj.filteredPropListPoly = [];
        this.data.pObj.unassignProploader = false;
        if (data?.length) {
          data.forEach(e => {
            address = '';
            images = [];
            if (e.own_address) {
              address = this.fnc.getAddressText(e.own_address);
            }
            if (e.data) {
              property_name = e.data.property_name ?? 'Property Name';
              build_year = e.data.build_year ?? 'UC';
              if (e.data.property_category) category = e.data.property_category;
              if (e.data.images) {
                img_list = e.data.images;
                if (img_list.length > 0) {
                  img_url = img_list[0][0];
                  image = this.fnc.getArrayValue('2', true, img_list); //get default property image
                  if (image) {
                    img_url = image[0];
                  }
                }
              }
              if (!img_url) img_url = "../assets/images/building_icon.png";
            }

            this.data.pObj.filteredPropListPolymain.push({
              id: e.property_id,
              uid: e.property_uid,
              property_name: property_name,
              userId: e.assigned_to,
              imageURL: img_url,
              username: 'string',
              buildYear: build_year,
              category: category,
              address: address
            });
          });

        }
        this.data.pObj.filteredPropListPoly = this.data.pObj.filteredPropListPolymain
        if (!is_scroll && !isLimit) {
          this.data.pObj.getCount('property_notinassignment');
        }
        this.closeDialog();
      }, error: (err) => {
        this.getPropertyLoader = false;
        if (!is_scroll && !isLimit) {
          this.data.pObj.getCount('property_notinassignment');
        }
        this.notify.notify(this.fnc.getErrorMessage(err), "error");
        this.data.pObj.unassignProploader = false;

        if (!is_scroll) {
          this.data.pObj.filteredPropListPoly = [];
        }
      }});
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
